import { ShowToastError } from "@platformx/utilities";
import graphqlInstance from "../config/graphqlConfig";
import { DashboardQueries } from "../graphQL/dashboardQueries";
import { ApiResponse } from "../utils/common.types";

const dashboardApi = {
  fetchStaticSiteDetails: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: DashboardQueries.GET_STATIC_SITE_DETAILS,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      return {
        data: null,
        error: err,
        loading: false,
      };
    }
  },
  generateStaticSite: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.mutate({
        mutation: DashboardQueries.GENERATE_STATIC_SITE,
        variables: input,
      });
      return data;
    } catch (err: any) {
      const statusCode = err?.networkError?.statusCode || 0;
      ShowToastError(`${err.graphQLErrors[0].message}`, statusCode);
      console.error(`Error in creating site`, err);
      throw err;
    }
  },
};
export default dashboardApi;
